<template>
    <div
        class="kgr-inputGroup"
        :class="{ 'is-invalid': error.forField('file') }"
    >
        <div class="kgr-row kgr-row--bigMargin">
            <div class="kgr-profileImage kgr-profileImage--sizeL">
                <img
                    :src="avatarUrl(clubEmployeeAccountSettings)"
                    :alt="clubEmployeeAccountSettings.fullname"
                    class="kgr-profileImage__image"
                />
            </div>
        </div>
        <kgr-file-chooser @change="onAvatarChange" />
        <template v-if="avatarFile">
            <hr class="kgr-separator kgr-separator--light" />
            <kgr-button
                :value="$t('Foto hochladen')"
                :pending="pendingUpload"
                type="blue"
                @click="uploadAvatar"
            />
        </template>
        <template v-if="clubEmployeeAccountSettings.hasAvatar && !avatarFile">
            <hr class="kgr-separator kgr-separator--light" />
            <a
                class="kgr-button kgr-button--small kgr-button--danger"
                href="javascript:void(0);"
                @click="deleteAvatar()"
            >{{ $t('Foto löschen?') }}</a>
            <input
                id="check_remove_image"
                type="hidden"
                value="0"
                name="check_remove_image"
            />
        </template>

        <div
            v-if="error.forField('file')"
            class="kgr-inputGroup__text kgr-inputGroup__text--error"
        >
            {{ error.messageForField('file') }}
        </div>
        <div class="kgr-inputGroup__text">
            {{ $t('Hier können Sie ein Profilbild einfügen. Die Grafikdatei (z.B. JPG, PNG oder GIF) sollte eine Mindestbreite von 300 Pixel haben und darf eine Dateigröße von 2 MB nicht überschreiten.') }}
        </div>
    </div>
</template>

<script>
import AccountSettings from '../../js/dto/AccountSettings';
import AvatarUrlGenerator from '../../js/service/AvatarUrlGenerator';
import ClubEmployeeAccountSettingsRepository from '../../js/repository/ClubEmployeeAccountSettingsRepository';
import Error from '../../js/model/Error';
import FileChooser from '../common/file/FileChooser';
import KgrButton from '../common/form/button/KgrButton';

export default {
    components: {
        'kgr-file-chooser': FileChooser,
        'kgr-button': KgrButton,
    },
    props: {
        clubEmployeeAccountSettings: {
            type: AccountSettings,
            required: true,
        }
    },
    data() {
        return {
            avatarFile: null,
            error: new Error(),
            pendingUpload: false,
        }
    },
    methods: {
        avatarUrl() {
            return AvatarUrlGenerator.clubEmployeeAvatarUrl(this.clubEmployeeAccountSettings, 'avatar', true);
        },
        deleteAvatar() {
            showConfirm(this.$t('confirm'), this.$t('Soll das Foto wirklich gelöscht werden?'), () => {
                ClubEmployeeAccountSettingsRepository.removeAvatar(this.clubEmployeeAccountSettings.id)
                    .then(() => {
                        this.error = new Error();
                        this.clubEmployeeAccountSettings.hasAvatar = false;
                        this.avatarFile = null;
                        this.$forceUpdate();
                        this.$notify.success('Foto erfolgreich gelöscht');
                    })
                    .catch(error => this.handleError(error));
            }, 'Ok');
        },
        onAvatarChange(avatarFile) {
            this.avatarFile = avatarFile;
        },
        uploadAvatar() {
            if (this.avatarFile) {
                this.pendingUpload = true;
                ClubEmployeeAccountSettingsRepository.uploadAvatar(this.clubEmployeeAccountSettings.id, this.avatarFile)
                    .then(() => {
                        this.error = new Error();
                        this.clubEmployeeAccountSettings.hasAvatar = true;
                        this.avatarFile = null;

                        this.$forceUpdate();
                        this.$notify.success('Foto erfolgreich hochgeladen');
                    })
                    .catch(error => this.handleError(error))
                    .finally(() => this.pendingUpload = false)
            }
        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
